import styled from 'styled-components';
import {Wrapper as Container} from './components/Folder/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Button = styled(Container)`
    
`;
